import usersApi from '@/api/usersApi'
import { debounce } from '@/utils/utils'
import axios from 'axios'
import { config, url } from '@/store'
// import { deleteToggleItems, toggleAll, toggleItem } from '@/utils/table/table'

const state = () => ({
  // table
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Ф.И.О.',
        isSortable: true,
        sortName: 'profiles.surname',
        dispatchName: 'userListPage/getUsersSort'
      },
      {
        title: 'Статус',
        isSortable: true,
        sortName: 'worker_statuses.name',
        dispatchName: 'userListPage/getUsersSort'
      },
      {
        title: 'Номер телефона',
        isSortable: false
      },
      {
        title: 'E-mail',
        isSortable: false
      },
      {
        title: 'Должность',
        isSortable: true,
        sortName: 'positions.name',
        dispatchName: 'userListPage/getUsersSort'
      },
      {
        title: 'Подразделение',
        isSortable: true,
        sortName: 'departments.name',
        dispatchName: 'userListPage/getUsersSort'
      }
    ]
  },
  users: [],
  isLoading: true,
  searchValue: '',
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  sort: {},
  filter: {},
  debounce: null,
  isActiveDelete: false,
  isTableLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  }
})

const getters = {
  allUsers: state => state.users,
  userListPageIsLoading: state => state.isLoading,
  pagination: state => state.pagination,
  filter: state => state.filter,
  searchValue: state => state.searchValue,
  isActiveDelete: state => state.isActiveDelete,
  isTableLoading: state => state.isTableLoading,
  deleteResponseModal: state => state.responseModal,
  tableHeaders: state => state.tableHeaders
}

const mutations = {
  // получение списка пользователей
  GET_USERS: (state, users) => {
    // добавляем к каждому пользователю свойство для отрисовки состояния меню (ред./удалить)
    // и делаем доп проверки так как profile может быть null и сломает список
    state.users = users.map(user => {
      return {
        ...user,
        phone: user.phone ? user.phone : 'Не указан',
        email: user.email ? user.email : 'Не указан',
        profile: user.profile ? {
          ...user.profile,
          name: user.profile.name ? user.profile.name : 'Не указано',
          surname: user.profile.patronymic ? user.profile.patronymic : 'Не указано',
          patronymic: user.profile.patronymic ? user.profile.patronymic : 'Не указано',
          full_name: user.profile.full_name ? user.profile.full_name : 'Не указано',
          fired: user.profile.fired
        } : {},

        isControlsActive: false,
        isActive: false
      }
    })
  },
  // вкл/выкл меню (редактировать/удалить)
  USER_LIST_TOGGLE_CONTROLS: (state, itemId) => {
    state.users.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  // выкл меню (редактировать/удалить) при клике вне элемента
  CLOSE_USER_LIST_CONTROLS: (state) => {
    state.users.forEach((elem) => {
      elem.isControlsActive = false
      elem.isActive = false
    })
  },
  // записть в стейт состояния пагинации
  SET_USERS_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },

  RESET_USERS_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },
  SET_CURRENT_PAGE: (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  SET_USERS_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // sort
  SET_USERS_LIST_SORT: (state, sortOptions) => {
    state.sort = sortOptions
  },

  SET_DEBOUNCE: (state, debounce) => {
    state.debounce = debounce
  },

  TOGGLE_USERS_LIST_ITEM_ACTIVE: (state, itemId) => {
    const itemsLength = state.users.length
    let counter = 0

    state.users.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })
    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false
    state.tableHeaders.allActive = counter === itemsLength
  },

  TOGGLE_USERS_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.users.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  SET_TABLE_LOADING: (state, loading) => {
    state.isTableLoading = loading
  },
  // delete checked items
  DELETE_USER_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили пользователя(ей)'
    state.responseModal.type = 'main'
  },
  DELETE_USER_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems
    errorItems.forEach(e => {
      listNamesErrorItems = listNamesErrorItems + ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении пользователя произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },
  CLOSE_DELETE_USER_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  RESET_USER_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.users.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },

  // filter
  SET_USER_LIST_FILTER: (state, filter) => {
    state.filter = filter
  },
  CLEAR_USER_LIST_FILTER: (state, filter) => {
    state.filter = filter
  },

  // reset store
  RESET_USER_LIST_STORE: (state) => {
    state.searchValue = ''
    state.sort = {}
    state.filter = {}
    state.pagination.currentPage = 1
  }
}

const actions = {
  getUsers ({ commit, state }) {
    const params = {
      expand: 'profile,birthFrom,birthTo,employmentFrom,employmentTo,department,position,employment,status,has_children',
      sort: (state.sort.descending ? '-' : '') + (state.sort.name || 'id'),
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      'search[all]': state.searchValue || null
    }

    for (const key in state.filter) {
      if (state.filter[key]) {
        params[`search[${key}]`] = state.filter[key]
      }
    }

    commit('SET_TABLE_LOADING', true)
    axios.get(`${url}/users`, { params, ...config })
      .then(response => {
        commit('GET_USERS', response.data.data)
        commit('SET_USERS_PAGINATION', response.headers)
      }).catch(error => {
        console.log('ошибка получения списка сотрудников', error)
      }).finally(() => {
        state.isTableLoading = false
        state.isLoading = false
      })
  },
  getUsersListPage ({ commit, dispatch }, pageNum) {
    commit('SET_CURRENT_PAGE', pageNum)
    dispatch('getUsers')
  },
  resetUsersCurrentPage ({ commit }) {
    commit('RESET_USERS_CURRENT_PAGE')
  },
  setUsersSearchValue ({ commit, dispatch, state }, searchValue) {
    commit('SET_USERS_SEARCH_VALUE', searchValue)
    if (!state.debounce) {
      commit('SET_DEBOUNCE', debounce(function () {
        commit('RESET_USERS_CURRENT_PAGE')
        dispatch('getUsers')
        commit('SET_DEBOUNCE', null)
      }, 500))
      state.debounce()
    }
  },
  toggleUsersPageList ({ commit }) {
    commit('TOGGLE_USERS_PAGE_LIST')
  },
  // переключение всплывающих меню (ред./удалить) в списке пользователей
  toggleUserListItemControls ({ commit }, itemId) {
    commit('USER_LIST_TOGGLE_CONTROLS', itemId)
  },
  // удаление пользователя
  deleteUserFromUserList ({ commit }, userId) {
    usersApi.deleteUser(userId).then(response => {
      this.dispatch('getUsers')
    }).catch(error => {
      console.log('Ошибка удаления пользователя:' + error)
    })
  },

  toggleUsersListItemActive ({ commit }, itemId) {
    commit('TOGGLE_USERS_LIST_ITEM_ACTIVE', itemId)
  },
  toggleUsersListItemActiveAll ({ commit }) {
    commit('TOGGLE_USERS_LIST_ITEM_ACTIVE_ALL')
  },

  toggleUserListFilter ({ commit }) {
    commit('TOGGLE_USER_LIST_FILTER')
  },
  closeUserListFilter ({ commit }) {
    commit('CLOSE_USER_LIST_FILTER')
  },

  toggleUserListFilterChildren ({ commit }) {
    commit('TOGGLE_USER_LIST_FILTER_CHILDREN')
  },

  // sort
  getUsersSort ({ commit, dispatch }, sort) {
    commit('SET_USERS_LIST_SORT', sort)
    dispatch('getUsers')
  },

  // delete checked items
  deleteUserListCheckedItems ({ commit, state }) {
    const checkedItems = []
    const errorItems = []
    state.users.forEach((e) => {
      if (e.isActive) {
        checkedItems.push(e)
      }
    })

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/users/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления пользователя', error)
        })
      }
    }
    processMessages(checkedItems).then(() => {
      if (errorItems.length > 0) {
        commit('RESET_USER_LIST_ALL_CHECKS')
        commit('DELETE_USER_LIST_CHECKED_ITEMS_ERROR', errorItems)
        this.dispatch('userListPage/getUsers')
      } else {
        commit('RESET_USER_LIST_ALL_CHECKS')
        commit('DELETE_USER_LIST_CHECKED_ITEMS_SUCCESS')
        this.dispatch('userListPage/getUsers')
      }
    })
  },
  closeUserListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_USER_LIST_MODAL')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
